import JustValidate from 'just-validate';
import Utils from '../../assets/scripts/utils/utils';
import Popups from '../../components/popups/popups';
import { getTelRules } from '../../assets/scripts/utils/validationRules';

const ClassName = {
	SMS_CODE: '_sms-code',
	SEND_CODE: '_send-code',
};

class OrderAuth {
	constructor() {
		this.init();
	}

	init() {
		this.container = document.querySelector('[data-order-auth]');

		if (!this.container) return;

		this._initValidation();
		this.container.showTimer = this.showTimer.bind(this);
	}

	_initValidation() {
		const form = this.container.querySelector('form');

		if (!form || form.inited) {
			return;
		}

		const submitButton = form.querySelector('.order-auth__submit');
		const telInput = form.querySelector('#order-auth-tel');

		// form.addEventListener('submit', (evt) => {
		// 	evt.preventDefault();

		// 	const popup = Popups.getPopup('confirm-tel');

		// 	if (!popup) {
		// 		return;
		// 	}

		// 	const telText = popup.querySelector('.confirm-tel__tel');
		// 	const code = telInput.getAttribute('data-country-code');

		// 	telText.textContent = `${code} ${telInput.value}`;

		// 	const form = Popups.getPopup('confirm-tel').querySelector('form');
		// 	if (form.hasAttribute('data-confirm-tel-timeout')) {
		// 		this.showTimer(Number(form.getAttribute('data-confirm-tel-timeout')));
		// 	}

		// });
		// Popups.open('confirm-tel');

		const validator = new JustValidate(form, {
			validateBeforeSubmitting: true,
		});

		form.validator = validator;

		validator
			.addField('#order-auth-tel', getTelRules('#order-auth-tel'), {
				errorsContainer: Utils.getErrorContainer('#order-auth-tel'),
			})
			.onValidate(({ isValid }) => {
				submitButton.disabled = !isValid;
			});

		telInput.addEventListener('countrychange', () => {
			setTimeout(() => {
				form.validator.validate();
			}, 50);
		});

		submitButton.disabled = !validator.isValid;
		form.inited = true;
	}
	showTimer(value, form = Popups.getPopup('confirm-tel').querySelector('form')) {
		const smsTimeoutValue = form.querySelector('[data-sms-timeout-value]');
		const smsButton = form.querySelector('[data-sms-timeout-start]');
		const smsInput = form.querySelector('[data-input-sms-code]');
		const firstInput = smsInput.smsCode.inputs[0];

		if (!form || !smsTimeoutValue || form.running) {
			return;
		}

		const updateTimerText = (val) => {
			smsTimeoutValue.textContent = val;
		};
		let counter = value;

		form.classList.remove(ClassName.SMS_CODE, ClassName.SEND_CODE);
		form.running = true;

		updateTimerText(counter);

		const timer = setInterval(() => {
			counter--;
			updateTimerText(counter);

			if (smsTimeoutValue.textContent <= 0) {
				clearInterval(timer);
				form.classList.remove(ClassName.SMS_CODE);
				form.classList.add(ClassName.SEND_CODE);
				form.running = false;
			}
		}, 1000);

		form.classList.add(ClassName.SMS_CODE);

		smsButton.addEventListener('click', () => this.showTimer(value, form), {
			once: true,
		});

		smsInput.smsCode.reset();
		firstInput.focus();
	}
}

export default new OrderAuth();
